module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCAxMDI0IDEwMjQiIHZlcnNpb249IjEuMSI+PHBhdGggZD0iTTM1OS4zIDQ5MGwyLjktMy40IDIuNS0yLjIgMjQ3LTI0OS45YTM1IDM1IDAgMCAxIDQ5LjkgMGMxMi43IDEyLjkgMTMuNyAzMy4xIDIuOSA0Ny4xbC0zIDMuNEw0MzcuMyA1MTJsMjI0LjQgMjI3YzEyLjcgMTIuOSAxMy43IDMzLjEgMyA0Ny4xbC0zIDMuNGEzNSAzNSAwIDAgMS00OS45IDBMMzY0LjggNTM5LjdsLTIuNS0yLjNjLTYuNC02LjQtOS44LTE0LjctMTAuMy0yMy4xdi00LjVhMzUuOCAzNS44IDAgMCAxIDcuMy0xOS44eiIgZmlsbD0iIzAiIHAtaWQ9IjU2NSI+PC9wYXRoPjwvc3ZnPg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/svg/Chevron left-outlined.svg
// module id = L8RD
// module chunks = 74